const createProxySessionErrorTypes = {
  INVALID_PHONE: 'error.invalid-phone',
};
export default createProxySessionErrorTypes;
